// App.jsx
import React, { useEffect } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Navbar from './component/Navbar';
import Footer from './component/Footer';

// Scroll to top on route change - FIXED
const ScrollController = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly with smooth behavior
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HashRouter>
      <ScrollController />
      <div className="App">
       
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
       
      </div>
    </HashRouter>
  );
}

export default App;